import { useNavigate } from 'react-router-dom';
import OnboardingTour, { type TourStep } from '../components/onboarding/OnboardingTour';

// Sprint ACAD ACT.A8 (#1709) — faculty supervisor first-login tour (3
// steps, per the AC): Cohort dashboard tour → Token alerts review prompt →
// Weekly report schedule configuration.
//
// Q9 adjudication — steps 2 and 3 point at ACT.A5's alert-inbox/cohort
// dashboard, which was still an OPEN, unmerged PR (#1764) at ACT.A8
// implementation time (re-checked live, not assumed from recon). Stubbed
// as "coming soon" here rather than built against or blocked entirely —
// once ACT.A5 merges, replace these two step bodies with real links into
// its dashboard (no change needed to the tour shell/progress wiring).

const STEPS: TourStep[] = [
  {
    title: 'Welcome, Faculty Supervisor',
    body: "Here's a quick tour of what you'll use most as you supervise your cohort's teams.",
  },
  {
    title: 'Cohort dashboard tour',
    body: 'Your cohort dashboard shows every team\'s current SDLC phase, gate status, and activity — accessible from the main navigation once your cohort has active teams.',
  },
  {
    title: 'Token alerts review',
    body: 'Coming soon — budget-alert review will appear here once the cohort dashboard ships.',
  },
  {
    title: 'Weekly report schedule',
    body: 'Coming soon — weekly report scheduling will appear here once the cohort dashboard ships.',
    cta: 'Done',
  },
];

export default function FacultyOnboardingPage() {
  const navigate = useNavigate();
  return (
    <OnboardingTour
      flowType="FACULTY_SUPERVISOR"
      steps={STEPS}
      onDone={() => navigate('/dashboard', { replace: true })}
    />
  );
}
